// src/pages/TrainingsPage.jsx
import React from "react";
import PageShell from "../components/layout/PageShell";
import TrainingGrid from "../features/training/TrainingGrid";
import ContactSection from "../components/shared/ContactSection";

export default function PublicTrainingsPage() {
  return (
    <PageShell>
      <TrainingGrid />
      <ContactSection />
    </PageShell>
  );
}